/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";

import { Link } from 'react-router-dom';

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

import React, { useEffect, useState, useCallback } from "react"

import { useHistory, useLocation } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getFullMemberRows } from 'tableHelper'
import { getAPIToken, getGuilds, getMembersForGuild } from 'GaiaAPI'
import { getValueFromString, calculateSS } from 'Utils'

import { FiTarget } from "react-icons/fi";
import { GiOctopus } from "react-icons/gi";
import { FaUsers } from "react-icons/fa6";
import { LuSwords } from "react-icons/lu";


function Guild() {
    const history = useHistory();
    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);
    const [guildname, setGuildName] = useState([]);
    const [guilds, setGuilds] = useState([]);

    const [guildColour, setGuildColour] = useState([]);
    const [membersCount, setMembersCount] = useState([]);
    const [power, setPower] = useState([]);
    const [powerInc, setPowerInc] = useState([]);
    const [powerIncColour, setPowerIncColour] = useState([]);
    const [seScore, setseScore] = useState([]);
    const [sePos, setsePos] = useState([]);
    const [avgGW, setAvgGW] = useState([]);
    const [avgCCL, setAvgCCL] = useState([]);

    const [members, setMembers] = useState([]);
    const [memberRows, setMemberRows] = useState([]);

    const [menu, setMenu] = useState(null);

    const openMenu = ({ currentTarget }) => setMenu(currentTarget);
    const closeMenu = () => setMenu(null);
    const sortbyPower = () => {
        members.sort(function (a, b) {
                if (getValueFromString(a.power) < getValueFromString(b.power))
                    return 1;
                if (getValueFromString(a.power) > getValueFromString(b.power))
                    return -1;
            return 0; });
        setMemberRows(getFullMemberRows(memberColumns, members, guilds));
        setMenu(null)
    };
    const sortbySE = () => {
        members.sort(function (a, b) {
            if (getValueFromString(a.se) < getValueFromString(b.se))
                return 1;
            if (getValueFromString(a.se) > getValueFromString(b.se))
                return -1;
            return 0;
        });
        setMemberRows(getFullMemberRows(memberColumns, members, guilds));
        setMenu(null)
    };
    const sortbyCCL = () => {
        members.sort(function (a, b) {
            if (getValueFromString(a.ccl) < getValueFromString(b.ccl))
                return 1;
            if (getValueFromString(a.ccl) > getValueFromString(b.ccl))
                return -1;
            return 0;
        });
        setMemberRows(getFullMemberRows(memberColumns, members, guilds));
        setMenu(null)
    };
    const sortbySS = () => {
        members.sort(function (a, b) {
            let valA = calculateSS(a);
            let valB = calculateSS(b);
            if (valA < getValueFromString(valB))
                return 1;
            if (valA > getValueFromString(valB))
                return -1;
            return 0;
        });
        setMemberRows(getFullMemberRows(memberColumns, members, guilds));
        setMenu(null)
    };

    const renderMenu = (
        <Menu
            id="simple-menu"
            anchorEl={menu}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menu)}
            onClose={closeMenu}
        >
            <MenuItem onClick={sortbyPower}>Power</MenuItem>
            <MenuItem onClick={sortbySE}>Star Expedition</MenuItem>
            <MenuItem onClick={sortbyCCL}>CCL</MenuItem>
            <MenuItem onClick={sortbySS}>Stellar Shards</MenuItem>
        </Menu>
    );

    function ordinal_suffix_of(i) {
        var j = i % 10,
            k = i % 100;
        if (j === 1 && k !== 11) {
            return i + "st";
        }
        if (j === 2 && k !== 12) {
            return i + "nd";
        }
        if (j === 3 && k !== 13) {
            return i + "rd";
        }
        return i + "th";
    }

    const memberColumns = [
        { name: "pos", align: "left" },
        { name: "name", align: "left" },
        { name: "power", align: "center" },
        { name: "power inc", align: "center" },
        { name: "ss", align: "center" },
        { name: "ccl", align: "center" },
        { name: "se score", align: "center" },
        { name: "s-tier", align: "center" },
        { name: "a-tier", align: "center" },
        { name: "d6", align: "center" },
        { name: "d5", align: "center" },
        { name: "d4", align: "center" },
        { name: "d3", align: "center" },
        { name: "d2", align: "center" },
        { name: "d1", align: "center" },
        { name: "t5", align: "center" },
        { name: "t4", align: "center" },
        { name: "t3", align: "center" },
        { name: "t2", align: "center" },
        { name: "t1", align: "center" },
        { name: "v4", align: "center" },
        { name: "v3", align: "center" },
        { name: "v2", align: "center" },
        { name: "v1", align: "center" }
    ]

    const getDetails = useCallback(async () => {
        let guildname = location.state.guildname;
        setGuildName(guildname)

        getUser()
            .then((result) => {
                setIsAdmin(result.isAdmin);

                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuilds(guildsResult);
                                let myGuild = guildsResult.find(g => g.name === guildname);

                                setMembersCount(myGuild.members);
                                setPowerIncColour("success");
                                setPower(myGuild.power);
                                setPowerInc(myGuild.powerInc);
                                setseScore(myGuild.seScore);
                                if (myGuild.sePosition)
                                    setsePos(ordinal_suffix_of(myGuild.sePosition));
                                setAvgGW(myGuild.avgGW);
                                setAvgCCL(myGuild.avgCCL);

                                if (myGuild && myGuild.colour)
                                    setGuildColour('#' + myGuild.colour);

                                getMembersForGuild(token, guildname)
                                    .then((membersResult) => {
                                        for (let i = 0; i < membersResult.length; i++) {
                                            membersResult[i].ss = calculateSS(membersResult[i]);
                                        }
                                        setMembers(membersResult);
                                        setMemberRows(getFullMemberRows(memberColumns, membersResult, guildsResult));
                                    },
                                        (error) => {
                                            alert(error);
                                        });
                            },
                            (error) => {
                                alert(error);
                                });
                    },
                    (error) => {
                        alert(error);
                    });
            },
            (error) => {
                history.push('/authentication/sign-in');
            });
    }, []);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} xl={3}>
                            <Card sx={{ padding: "17px" }} style={{ backgroundColor: guildColour }}>
                            <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                <VuiTypography variant="lg" color="white">
                                    {guildname}
                                    </VuiTypography>
                                </VuiBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            <MiniStatisticsCard
                                title={{ text: "Members", fontWeight: "regular" }}
                                count={membersCount}
                                percentage={{ color: membersCount < 30 ? "error" : "success", text: "/ 30" }}
                                icon={{ color: "info", component: <FaUsers size="20px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            <MiniStatisticsCard
                                title={{ text: "Power" }}
                                count={power}
                                percentage={{ color: powerIncColour, text: powerInc }}
                                icon={{ color: "info", component: <LuSwords size="22px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            <MiniStatisticsCard
                                title={{ text: "Star Expedition" }}
                                count={seScore}
                                percentage={{ color: "info", text: sePos }}
                                icon={{ color: "info", component: <GiOctopus size="20px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "Requirements" }}
                                count={"GW: " + avgGW + " Mil"}
                                percentage={{ color: "dark", text: " CCL: " + avgCCL + " Mil" }}
                                icon={{ color: "info", component: <FiTarget size="20px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            {isAdmin ? (
                                <Link to={{ pathname: '/guildsedit', state: { guildname: guildname } }}>
                                    <VuiButton
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        Set Ace/SE
                                        </VuiButton>
                                </Link>
                            ) : (
                                <VuiBox />
                            )}
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            {isAdmin ? (
                                <Link to={{ pathname: '/membersedit', state: { guildname: guildname } }}>
                                    <VuiButton
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        Edit Members
                                    </VuiButton>
                                </Link>
                            ) : (
                                <VuiBox />
                            )}
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            {isAdmin ? (
                                <Link to={{ pathname: '/member', state: { guildname: guildname } }}>
                                    <VuiButton
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        New Member
                                    </VuiButton>
                                </Link>
                            ) : (
                            <VuiBox />
                            )}
                        </Grid>
                    </Grid>
                </VuiBox>
                <VuiBox mb={3}>
                    <Card>
                        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                            <VuiTypography variant="lg" color="white">
                                Members
                            </VuiTypography>
                            <VuiBox>
                                <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                    show_chart
                                </Icon>
                                <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                    arrow_drop_down
                                </Icon>
                                {renderMenu}
                                </VuiBox>
                        </VuiBox>
                        <VuiBox
                            sx={{
                                "& th": {
                                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                        `${borderWidth[1]} solid ${grey[700]}`, 
                                },
                                "& tr": {
                                    fontSize: 12,
                                },
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({
                                            borders: { borderWidth }, palette: { grey } }) =>
                                            `${borderWidth[1]} solid ${grey[700]}`,
                                    },
                                },   
                                '& .MuiTableRow-root:nth-of-type(even)': {
                                    backgroundColor: "#00093D",
                                },
                            }}
                        >
                            <Table columns={memberColumns} rows={memberRows}/>
                        </VuiBox>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Guild;
